import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Contact from "./routes/contact";
import {NavLink} from "react-router-dom";
import {Link} from "react-router-dom";
import  { useState,Suspense } from "react";
import{
    createBrowserRouter,
    RouterProvider,
    Route
} from "react-router-dom";
import App from "./App";
import React from "react";
import './App.css';
import { motion } from 'framer-motion';
import './NavBoot.css';

const router1 = createBrowserRouter(
    [{
        path: "contact/",
        element: <Contact />,
    },
    ]);

function Navboot({ setCurrentTab }) {
    const handleSelect = (eventKey) => setCurrentTab(eventKey);

    return (
        <Nav 
            variant="pills" 
            defaultActiveKey="Home"
            onSelect={handleSelect}
            className="justify-content-center nav-container"
        >
            <Nav.Item>
                <Nav.Link eventKey="Home">Home</Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link eventKey="About">About</Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link eventKey="Experience">Experience</Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link eventKey="Education">Education</Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link eventKey="Skills">Skills</Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link eventKey="Projects">Projects</Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link eventKey="Publications">Publications</Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link eventKey="Certificates">Certificates</Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link eventKey="Honors">Honors</Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link eventKey="Contact">Contact</Nav.Link>
            </Nav.Item>
        </Nav>
    );
}

export default Navboot;